import 'antd/dist/antd.min.css'
import './assets/css/antd-design-utility.css'
import { LayoutLoader } from './containers/LayoutLoader/LayoutLoader';
import './App.css';

function App() {
  return (
    <>
      <LayoutLoader />
    </>
  );
}

export default App;
